import user from 'views/profile/user';

export default {
	...user,
};
